import { ReactNode } from 'react'
import Styles from './RequestCard.module.scss'

export const Header = ({ children }: { children: ReactNode }) => <div className={Styles.header}>{children}</div>
